import { TStoreInventory } from 'shared/types/cart';

const aggregatedQuantity = (sku: string | undefined, fluentStocks: TStoreInventory[]) => {
  if (!sku || (fluentStocks[0] && fluentStocks[0]?.productsStock == undefined)) return 0;

  return fluentStocks
    .map((store) =>
      store.productsStock
        .filter((product) => product.sku === sku)
        .reduce((sum, product) => sum + Number(product.quantity), 0),
    )
    .reduce((total, storeQuantity) => total + storeQuantity, 0);
};

export default aggregatedQuantity;
